import { withOnClickTracking } from 'auto-tracking';

import { styled, theme } from '../stitches.config';
import { rem } from '../util';

export const CtaButton = withOnClickTracking(
  styled('button', {
    backgroundColor: theme.colors.blue9,
    color: theme.colors.gray1,
    textDecoration: 'none',

    border: 'none',
    margin: 0,
    boxShadow: `${theme.shadows.shadow2} ${theme.colors.blueAlpha7}`,

    fontFamily: theme.fonts.sansSerif,
    fontWeight: theme.fontWeights.medium,
    lineHeight: rem(24),
    cursor: 'pointer',

    '&:hover': {
      boxShadow: `${theme.shadows.shadow3} ${theme.colors.blueAlpha7}`,
    },

    '&:active': {
      boxShadow: `${theme.shadows.shadow1} ${theme.colors.blueAlpha7}`,
    },

    '&:disabled': {
      backgroundColor: theme.colors.blue6,
      boxShadow: 'unset',
      color: theme.colors.blue3,
      cursor: 'unset',
    },

    '&:focus-visible': {
      boxShadow: `${theme.shadows.shadow3} ${theme.colors.yellowAlpha7}`,
      outline: `2px solid ${theme.colors.yellow8}`,
      outlineOffset: '2px',
    },

    variants: {
      size: {
        small: {
          borderRadius: rem(8),
          fontSize: rem(16),
          paddingTop: rem(12),
          paddingRight: rem(24),
          paddingBottom: rem(12),
          paddingLeft: rem(24),
        },
        big: {
          borderRadius: rem(10),
          fontSize: rem(19),
          paddingTop: rem(16),
          paddingRight: rem(32),
          paddingBottom: rem(16),
          paddingLeft: rem(32),
        },
      },
      split: {
        left: {
          marginRight: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          '&:focus-visible': {
            zIndex: 1,
          },
        },
        right: {
          marginLeft: 0,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          '&:focus-visible': {
            zIndex: 1,
          },
        },
      },
      square: {
        true: {},
      },
      dark: {
        true: {
          backgroundColor: theme.colors.blue10,
          '&:disabled': {
            backgroundColor: theme.colors.blue7,
          },
        },
      },
      fullWidth: {
        true: {
          width: '100%',
        },
      },
    },

    defaultVariants: {
      size: 'small',
    },

    compoundVariants: [
      {
        size: 'small',
        square: true,
        css: {
          paddingRight: rem(12),
          paddingLeft: rem(12),
        },
      },
      {
        size: 'big',
        square: true,
        css: {
          paddingRight: rem(16),
          paddingLeft: rem(16),
        },
      },
    ],
  }),
);
